import React, { Component } from "react";

import "../../assets/css/admin-styles.css";
import UserPanel from "./Components/UserPanel";


export default class UserAdminPage extends Component {
  constructor(props) {

    super(props);




    this.state = {
      tagCount: 0,
      showNewSubModal: false,
      forcePanelRefresh: false
    }

}






  render() {
    return (
      <>


      <div style={{ overflowX: "hidden" }}>
          <div>
            <UserPanel
              isConnected={this.props.isConnected}
              userSession={this.props.userSession}
              onLogoutRequest={this.props.onLogoutRequest} 
              panelRefreshRequest={this.state.forcePanelRefresh}
              onPanelRefreshComplete={this.onPanelRefreshComplete}
            />
          </div>
        </div></>
    );
  }
}
